import { render, staticRenderFns } from "./BTN005n_turning_right.vue?vue&type=template&id=1c1421b4&"
import script from "./BTN005n_turning_right.vue?vue&type=script&lang=js&"
export * from "./BTN005n_turning_right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports